export const PRICING_ID = 'pricing';
export const PLANS_ID = 'plans';
export const FEATURES_ID = 'features';
